// Notification helpers: audible beep (Web Audio, unlocked on first user gesture),
// blinking tab title, and shared new-message alerting.
let audioCtx = null;
let inited = false;

export function initAudioUnlock() {
  if (inited) return;
  inited = true;
  const unlock = () => {
    try {
      if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      if (audioCtx.state === "suspended") audioCtx.resume();
    } catch (e) {}
  };
  window.addEventListener("click", unlock);
  window.addEventListener("keydown", unlock);
  window.addEventListener("touchstart", unlock);
  window.addEventListener("focus", stopTitleBlink);
}

function tone(ctx, freq, start, dur) {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.connect(g);
  g.connect(ctx.destination);
  o.type = "sine";
  o.frequency.value = freq;
  const t = ctx.currentTime + start;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(0.35, t + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur + 0.02);
}

export function playBeep() {
  try {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    if (audioCtx.state === "suspended") audioCtx.resume();
    // pleasant two-note "ding-dong"
    tone(audioCtx, 880, 0, 0.28);
    tone(audioCtx, 1174.66, 0.16, 0.34);
  } catch (e) {}
}

let blinkTimer = null;
let originalTitle = null;
export function startTitleBlink(msg) {
  if (typeof document === "undefined") return;
  if (document.hasFocus && document.hasFocus()) return; // no blink if user is already looking
  if (blinkTimer) return;
  originalTitle = document.title;
  let on = false;
  blinkTimer = setInterval(() => {
    document.title = on ? originalTitle : msg;
    on = !on;
  }, 1000);
}

export function stopTitleBlink() {
  if (blinkTimer) {
    clearInterval(blinkTimer);
    blinkTimer = null;
    if (originalTitle != null) document.title = originalTitle;
  }
}
